import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Shared between kh-question-secondary-buttons (Listen button) and kh-question-gameplay
// (inline audio player + question text highlight) since they are sibling components.
@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {
  public readonly isOpen$ = new BehaviorSubject<boolean>(false);
  public readonly isPlaying$ = new BehaviorSubject<boolean>(false);
  public readonly audioSrc$ = new BehaviorSubject<string | null>(null);

  private objectUrl: string | null = null;

  public open(audio: Blob): void {
    this.revokeObjectUrl();
    this.objectUrl = URL.createObjectURL(audio);
    this.audioSrc$.next(this.objectUrl);
    this.isOpen$.next(true);
  }

  public close(): void {
    if (!this.isOpen$.value) {
      return;
    }

    this.isOpen$.next(false);
    this.isPlaying$.next(false);
    this.audioSrc$.next(null);
    this.revokeObjectUrl();
  }

  public setPlaying(isPlaying: boolean): void {
    this.isPlaying$.next(isPlaying);
  }

  private revokeObjectUrl(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }
}
